"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var enums_1 = require("../../../types/enums");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var RestrictionsDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.restrictions'), subHeading: trans('optiiva::headings.personal') }),
        client.block_referrals === enums_1.BooleanOption.YES && (react_1.default.createElement(__1.DataRow, { horizontal: true, flush: true, dropBorder: true, label: trans('optiiva::labels.block-referrals'), value: react_1.default.createElement("span", { className: "text-red font-semibold" }, trans('optiiva::messages.client-referrals-require-approval')) }))));
};
exports.default = RestrictionsDetailsProfile;
//# sourceMappingURL=RestrictionsDetailsProfile.js.map